require("@rails/ujs").start();
require("@rails/activestorage").start();

require("alpinejs");
import "../stylesheets/application.scss";
import "../images";
import wfalookupmodule_ from "../javascript/wfa.js";
import "chartkick/chart.js";
import { baseAutoCompleteConfig } from "../javascript/search/autocomplete_config";
import { initializeSearchBehavior } from "../javascript/search/search_behavior";
import "../javascript/stallions/tabs";

window.wfalookuptable = wfalookupmodule_.wfa;
window.baseAutoCompleteConfig = baseAutoCompleteConfig;
window.initializeSearchBehavior = initializeSearchBehavior;

window.popupWindow = function (url, title, win, h, w) {
  const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
  const x = win.innerWidth - w;
  win.open(
    url,
    title,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
  );
  return false;
};

window.setSelected = function (element) {
  var selected = element.getAttribute("data-selected");

  if (selected == "true") {
    element.setAttribute("data-selected", "false");
  } else {
    element.setAttribute("data-selected", "true");
  }
};

var PPL = {
  4: 3,
  5: 3.5,
  6: 3,
  7: 2.5,
  8: 2.2,
  9: 2,
  10: 1.8,
  11: 1.6,
  12: 1.5,
  13: 1.4,
  14: 1.3,
  15: 1.25,
  16: 1.2,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  22: 1,
  23: 1,
  24: 1,
};

window.rate_race = function (event) {
  const autoRateConfig = JSON.parse(window.auto_rate_details);
  const masterRating = parseFloat(event.value);

  const winnerId = event.dataset.id;

  let distanceFurlong = autoRateConfig.distance_furlongs;

  var closestPpl = Object.keys(PPL).reduce(function (prev, curr) {
    curr = parseInt(curr, 10);
    return Math.abs(curr - distanceFurlong) < Math.abs(prev - distanceFurlong)
      ? curr
      : prev;
  });
  const ppl = PPL[closestPpl];

  let autoRateEnabled = document.getElementById("auto_rate");

  if (!autoRateEnabled.checked) {
    return false;
  }

  var closestWfaDistance = Object.keys(
    window.wfalookuptable[autoRateConfig.wfa_race_type]
  ).reduce(function (prev, curr) {
    curr = parseInt(curr, 10);
    return Math.abs(curr - distanceFurlong) < Math.abs(prev - distanceFurlong)
      ? curr
      : prev;
  });
  const wfaLookup =
    window.wfalookuptable[autoRateConfig.wfa_race_type][
      closestWfaDistance.toString()
    ];

  console.log(
    "rate_race",
    autoRateConfig.wfa_race_type,
    "furlongs",
    distanceFurlong,
    "closest wfa distance",
    closestWfaDistance,
    wfaLookup
  );

  document.getElementById("ppl").innerHTML = ppl;

  let wfaConfig = {};

  const winner = autoRateConfig.runners[0];

  if (typeof wfaLookup !== "undefined") {
    if (wfaLookup[2]) {
      wfaConfig[2] = parseInt(
        wfaLookup[2][autoRateConfig.short_date][autoRateConfig.date_key],
        10
      );
    }

    if (wfaLookup[3]) {
      wfaConfig[3] = parseInt(
        wfaLookup[3][autoRateConfig.short_date][autoRateConfig.date_key],
        10
      );
    }

    if (wfaLookup[4]) {
      wfaConfig[4] = parseInt(
        wfaLookup[4][autoRateConfig.short_date][autoRateConfig.date_key],
        10
      );
    }
  }

  let hasWfa = false;

  if (typeof ppl !== "undefined") {
    // Master Rating + (distance beaten*-1*pounds per length) + weight carried in comparison to the winner
    const constWinnerWeightCarried =
      parseFloat(winner.handicap_weight_lbs) +
      parseFloat(winner.jockey_allowance_lbs);

    autoRateConfig.runners.forEach(function (runner) {
      const id = "ratings[" + runner.id + "]";
      const input = document.getElementById(id);

      if (
        runner.id != winnerId &&
        runner.finish_position &&
        runner.finish_position > 0
      ) {
        let margin = runner.margin;

        if (margin !== null) {
          margin = parseFloat(runner.margin);
        }

        const weightDelta =
          parseFloat(runner.handicap_weight_lbs) +
          parseFloat(runner.jockey_allowance_lbs) -
          constWinnerWeightCarried;
        let rating = masterRating + margin * -1 * ppl + weightDelta;

        if (runner.age > winner.age && wfaConfig[winner.age]) {
          hasWfa = true;
          rating -= wfaConfig[winner.age];
        } else if (wfaConfig[runner.age] && winner.age != runner.age) {
          hasWfa = true;
          rating += wfaConfig[runner.age];
        }

        if (rating > 0) {
          input.value = rating.toFixed(0);
        }
      }
    });
  }

  if (hasWfa) {
    document.getElementById("wfa-enabled").checked = true;
  }
};

window.updateHighlightEntriesDecs = function (el, colour) {
  const name = el.dataset.name;
  const venue = el.dataset.venue;
  const date = el.dataset.date;
  const eventTime = el.dataset.eventTime;

  const meet = {
    venue: venue,
    date: date,
    eventTime: eventTime,
  };

  fetch("/api/event_competitors/entries_decs/highlight", {
    method: "post",
    body: JSON.stringify({
      name: name,
      meet: meet,
      colour: colour,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

window.highlightCellByNameEntriesDecs = function (el, event) {
  // Prevent event bubbling and default behavior
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  if (el.classList.contains("bg-green-600")) {
    el.classList.remove("bg-green-600");
    el.classList.add("bg-yellow-300");

    updateHighlightEntriesDecs(el, "yellow");

    return;
  }

  if (el.classList.contains("bg-yellow-300")) {
    el.classList.remove("bg-yellow-300");
    el.classList.add("bg-red-600");

    updateHighlightEntriesDecs(el, "red");

    return;
  }

  if (el.classList.contains("bg-red-600")) {
    el.classList.remove("bg-red-600");

    updateHighlightEntriesDecs(el, "");

    return;
  }

  updateHighlightEntriesDecs(el, "green");

  el.classList.add("bg-green-600");
};
